<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Visitas Domiciliares"
            description="Visitas realizadas pelo ACS"
            url="/dashboard"
          />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link :to="item.link">
            <div class="item">
              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img v-else-if="item.imagem !== ''" :src="item.imagem" alt="" />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import FamiliasVisitadas from '@/components/icons/VisitasDomiciliares/FamiliasVisitadas.vue'
import CidadaosVisitados from '@/components/icons/VisitasDomiciliares/CidadaosVisitados.vue'
import DesempenhoPorAcs from '@/components/icons/VisitasDomiciliares/DesempenhoPorAcs.vue'

export default {
  name: 'VisitasDomiciliares',
  metaInfo: {
    title: 'Visitas Domiciliares',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    FamiliasVisitadas,
    CidadaosVisitados,
    DesempenhoPorAcs,
  },
  computed: {
    cards() {
      return this.$store.state?.permissoes?.visitas_domiciliares
    },
  },
  data() {
    return {}
  },
}
</script>

<style></style>
